module.exports = __webpack_public_path__ + "static/Aboubakar.8ccbdaf9.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team/Aboubakar.jpeg
// module id = 930
// module chunks = 3